import { Utensils } from 'lucide-react';

export interface MealSlotProps {
  menuName: string;
  weekDay: string;
}

/**
 * Empty dashed placeholder card explaining why there's only one menu option today.
 * Matches HR Module Prototype `.meal-slot`.
 */
export const MealSlot = ({ menuName, weekDay }: MealSlotProps) => {
  return (
    <div
      aria-hidden="true"
      className="hidden flex-col items-center justify-center gap-2.5 rounded-lg border border-dashed border-border p-6 text-center text-sm text-muted-foreground sm:flex"
    >
      <Utensils className="size-5 opacity-50" />
      <span>
        {menuName} is the only menu on {weekDay}
      </span>
    </div>
  );
};
